import { useEffect, useState } from "react";
import "./CookieBanner.css";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const accepted = localStorage.getItem("cookie-consent");
    if (!accepted) setVisible(true);
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookie-consent", "true");
    setVisible(false);
  };

  const openPdf = () => {
    window.open("/politicas/politica-cookies.pdf", "_blank");
  };

  if (!visible) return null;

  return (
    <div className="cookie-banner">
      <span>
        EEste sitio web utiliza Cookies propias para recopilar información con la finalidad técnica, 
        no se recaban ni ceden sus datos de carácter personal sin su consentimiento. Asimismo, se 
        informa que este sitio web dispone de enlaces a sitios web de terceros con políticas 
        de privacidad ajenas a CUALO INNOVATION CONSULTING S.L.
      </span>

      <button className="cookie-accept-button" onClick={acceptCookies}>
        Aceptar
      </button>

      <button className="cookie-moreinfo-button" onClick={openPdf}>
        Más Información
      </button>
    </div>
  );
}
